module.exports = __webpack_public_path__ + "static/media/25105560_1545557682160534_1151897978_n_edited.34638689.jpg";